import { DisplayWhenHasModules } from 'components.layouts/five-up/five-up-utils.js';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { filterOutHiddenModules } from 'layout/utils-hide-when.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { MapSlotContext } from './map-slot-context.js';

export const MapLeftSlotDynamic = ({ classes, name }: { classes: string; name: string }) => {
  const { mapSlot } = useContext(MapSlotContext);
  const columnLayout = useContext(ScreenSizeContext);
  const finalMapSlots = filterOutHiddenModules(columnLayout, mapSlot);

  return (
    <>
      <DisplayWhenHasModules section={finalMapSlots}>
        <ModulesLazyLoadWrapper section={getModulesMetaData(`${name}-mapSlot`, mapSlot)} className={classes}>
          <ModuleArrLoad modules={finalMapSlots} modulePath={ModulePath.MAP_SLOT_DYNAMIC} />
        </ModulesLazyLoadWrapper>
      </DisplayWhenHasModules>
    </>
  );
};
